module.exports = __webpack_public_path__ + "img/orange-square-table-12.e1ddd163.png";